var Ce = Object.defineProperty;
var De = (e, a, n) => a in e ? Ce(e, a, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[a] = n;
var w = (e, a, n) => De(e, typeof a != "symbol" ? a + "" : a, n);
import Le from "i18next";
import { useTranslation as ye, I18nextProvider as we, initReactI18next as Ue } from "react-i18next";
import { jsxs as We, jsx as U } from "react/jsx-runtime";
import { ConfigProvider as Fe } from "antd";
import ke from "antd/lib/locale/en_US";
import { Suspense as Ge } from "react";
import { ImprHeaders as S, Logger as ae, getConfig as ce, debug as ue, instrument as Me, createSpanName as xe, SpanComponent as He } from "@imprivata-cloud/common";
import { getRSAPublicKey as Ye, CodingContext as ne, base64ToJson as F } from "@imprivata-cloud/dataprivacy";
import { A as v } from "./api-DwyZ-w1t.js";
import Xe from "axios";
const Ve = () => {
  const { t: e } = ye();
  return /* @__PURE__ */ We("div", { children: [
    e("loading"),
    "..."
  ] });
};
function de(e, a) {
  if (!(e instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function C(e) {
  "@babel/helpers - typeof";
  return C = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
    return typeof a;
  } : function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, C(e);
}
function $e(e, a) {
  if (C(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var t = n.call(e, a);
    if (C(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Ke(e) {
  var a = $e(e, "string");
  return C(a) == "symbol" ? a : a + "";
}
function Be(e, a) {
  for (var n = 0; n < a.length; n++) {
    var t = a[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, Ke(t.key), t);
  }
}
function he(e, a, n) {
  return a && Be(e.prototype, a), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var me = [], je = me.forEach, qe = me.slice;
function ze(e) {
  return je.call(qe.call(arguments, 1), function(a) {
    if (a)
      for (var n in a)
        e[n] === void 0 && (e[n] = a[n]);
  }), e;
}
var te = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, Qe = function(a, n, t) {
  var i = t || {};
  i.path = i.path || "/";
  var o = encodeURIComponent(n), s = "".concat(a, "=").concat(o);
  if (i.maxAge > 0) {
    var l = i.maxAge - 0;
    if (Number.isNaN(l)) throw new Error("maxAge should be a Number");
    s += "; Max-Age=".concat(Math.floor(l));
  }
  if (i.domain) {
    if (!te.test(i.domain))
      throw new TypeError("option domain is invalid");
    s += "; Domain=".concat(i.domain);
  }
  if (i.path) {
    if (!te.test(i.path))
      throw new TypeError("option path is invalid");
    s += "; Path=".concat(i.path);
  }
  if (i.expires) {
    if (typeof i.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    s += "; Expires=".concat(i.expires.toUTCString());
  }
  if (i.httpOnly && (s += "; HttpOnly"), i.secure && (s += "; Secure"), i.sameSite) {
    var m = typeof i.sameSite == "string" ? i.sameSite.toLowerCase() : i.sameSite;
    switch (m) {
      case !0:
        s += "; SameSite=Strict";
        break;
      case "lax":
        s += "; SameSite=Lax";
        break;
      case "strict":
        s += "; SameSite=Strict";
        break;
      case "none":
        s += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return s;
}, ie = {
  create: function(a, n, t, i) {
    var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    t && (o.expires = /* @__PURE__ */ new Date(), o.expires.setTime(o.expires.getTime() + t * 60 * 1e3)), i && (o.domain = i), document.cookie = Qe(a, encodeURIComponent(n), o);
  },
  read: function(a) {
    for (var n = "".concat(a, "="), t = document.cookie.split(";"), i = 0; i < t.length; i++) {
      for (var o = t[i]; o.charAt(0) === " "; ) o = o.substring(1, o.length);
      if (o.indexOf(n) === 0) return o.substring(n.length, o.length);
    }
    return null;
  },
  remove: function(a) {
    this.create(a, "", -1);
  }
}, Je = {
  name: "cookie",
  lookup: function(a) {
    var n;
    if (a.lookupCookie && typeof document < "u") {
      var t = ie.read(a.lookupCookie);
      t && (n = t);
    }
    return n;
  },
  cacheUserLanguage: function(a, n) {
    n.lookupCookie && typeof document < "u" && ie.create(n.lookupCookie, a, n.cookieMinutes, n.cookieDomain, n.cookieOptions);
  }
}, Ze = {
  name: "querystring",
  lookup: function(a) {
    var n;
    if (typeof window < "u") {
      var t = window.location.search;
      !window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1 && (t = window.location.hash.substring(window.location.hash.indexOf("?")));
      for (var i = t.substring(1), o = i.split("&"), s = 0; s < o.length; s++) {
        var l = o[s].indexOf("=");
        if (l > 0) {
          var m = o[s].substring(0, l);
          m === a.lookupQuerystring && (n = o[s].substring(l + 1));
        }
      }
    }
    return n;
  }
}, _ = null, oe = function() {
  if (_ !== null) return _;
  try {
    _ = window !== "undefined" && window.localStorage !== null;
    var a = "i18next.translate.boo";
    window.localStorage.setItem(a, "foo"), window.localStorage.removeItem(a);
  } catch {
    _ = !1;
  }
  return _;
}, ea = {
  name: "localStorage",
  lookup: function(a) {
    var n;
    if (a.lookupLocalStorage && oe()) {
      var t = window.localStorage.getItem(a.lookupLocalStorage);
      t && (n = t);
    }
    return n;
  },
  cacheUserLanguage: function(a, n) {
    n.lookupLocalStorage && oe() && window.localStorage.setItem(n.lookupLocalStorage, a);
  }
}, O = null, se = function() {
  if (O !== null) return O;
  try {
    O = window !== "undefined" && window.sessionStorage !== null;
    var a = "i18next.translate.boo";
    window.sessionStorage.setItem(a, "foo"), window.sessionStorage.removeItem(a);
  } catch {
    O = !1;
  }
  return O;
}, aa = {
  name: "sessionStorage",
  lookup: function(a) {
    var n;
    if (a.lookupSessionStorage && se()) {
      var t = window.sessionStorage.getItem(a.lookupSessionStorage);
      t && (n = t);
    }
    return n;
  },
  cacheUserLanguage: function(a, n) {
    n.lookupSessionStorage && se() && window.sessionStorage.setItem(n.lookupSessionStorage, a);
  }
}, na = {
  name: "navigator",
  lookup: function(a) {
    var n = [];
    if (typeof navigator < "u") {
      if (navigator.languages)
        for (var t = 0; t < navigator.languages.length; t++)
          n.push(navigator.languages[t]);
      navigator.userLanguage && n.push(navigator.userLanguage), navigator.language && n.push(navigator.language);
    }
    return n.length > 0 ? n : void 0;
  }
}, ta = {
  name: "htmlTag",
  lookup: function(a) {
    var n, t = a.htmlTag || (typeof document < "u" ? document.documentElement : null);
    return t && typeof t.getAttribute == "function" && (n = t.getAttribute("lang")), n;
  }
}, ia = {
  name: "path",
  lookup: function(a) {
    var n;
    if (typeof window < "u") {
      var t = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (t instanceof Array)
        if (typeof a.lookupFromPathIndex == "number") {
          if (typeof t[a.lookupFromPathIndex] != "string")
            return;
          n = t[a.lookupFromPathIndex].replace("/", "");
        } else
          n = t[0].replace("/", "");
    }
    return n;
  }
}, oa = {
  name: "subdomain",
  lookup: function(a) {
    var n = typeof a.lookupFromSubdomainIndex == "number" ? a.lookupFromSubdomainIndex + 1 : 1, t = typeof window < "u" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (t)
      return t[n];
  }
}, Pe = !1;
try {
  document.cookie, Pe = !0;
} catch {
}
var Se = ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"];
Pe || Se.splice(1, 1);
function sa() {
  return {
    order: Se,
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: function(a) {
      return a;
    }
  };
}
var fe = /* @__PURE__ */ function() {
  function e(a) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    de(this, e), this.type = "languageDetector", this.detectors = {}, this.init(a, n);
  }
  return he(e, [{
    key: "init",
    value: function(n) {
      var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = n || {
        languageUtils: {}
      }, this.options = ze(t, this.options || {}, sa()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = function(o) {
        return o.replace("-", "_");
      }), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = i, this.addDetector(Je), this.addDetector(Ze), this.addDetector(ea), this.addDetector(aa), this.addDetector(na), this.addDetector(ta), this.addDetector(ia), this.addDetector(oa);
    }
  }, {
    key: "addDetector",
    value: function(n) {
      return this.detectors[n.name] = n, this;
    }
  }, {
    key: "detect",
    value: function(n) {
      var t = this;
      n || (n = this.options.order);
      var i = [];
      return n.forEach(function(o) {
        if (t.detectors[o]) {
          var s = t.detectors[o].lookup(t.options);
          s && typeof s == "string" && (s = [s]), s && (i = i.concat(s));
        }
      }), i = i.map(function(o) {
        return t.options.convertDetectedLanguage(o);
      }), this.services.languageUtils.getBestMatchFromCodes ? i : i.length > 0 ? i[0] : null;
    }
  }, {
    key: "cacheUserLanguage",
    value: function(n, t) {
      var i = this;
      t || (t = this.options.caches), t && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(n) > -1 || t.forEach(function(o) {
        i.detectors[o] && i.detectors[o].cacheUserLanguage(n, i.options);
      }));
    }
  }]);
}();
fe.type = "languageDetector";
var pe = [], ra = pe.forEach, la = pe.slice;
function ca(e) {
  return ra.call(la.call(arguments, 1), function(a) {
    if (a)
      for (var n in a)
        e[n] === void 0 && (e[n] = a[n]);
  }), e;
}
function ua(e) {
  return e ? typeof e == "function" ? new e() : e : null;
}
function da() {
  return {
    handleEmptyResourcesAsFailed: !0,
    cacheHitMode: "none"
    // reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000
    // refreshExpirationTime: 60 * 60 * 1000
  };
}
function re(e, a, n, t) {
  var i = e.read.bind(e);
  if (i.length === 2) {
    try {
      var o = i(a, n);
      o && typeof o.then == "function" ? o.then(function(s) {
        return t(null, s);
      }).catch(t) : t(null, o);
    } catch (s) {
      t(s);
    }
    return;
  }
  i(a, n, t);
}
var Ee = /* @__PURE__ */ function() {
  function e(a) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    de(this, e), this.backends = [], this.type = "backend", this.allOptions = t, this.init(a, n);
  }
  return he(e, [{
    key: "init",
    value: function(n) {
      var t = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = n, this.options = ca(i, this.options || {}, da()), this.allOptions = o, this.options.backends && this.options.backends.forEach(function(s, l) {
        t.backends[l] = t.backends[l] || ua(s), t.backends[l].init(n, t.options.backendOptions && t.options.backendOptions[l] || {}, o);
      }), this.services && this.options.reloadInterval && setInterval(function() {
        return t.reload();
      }, this.options.reloadInterval);
    }
  }, {
    key: "read",
    value: function(n, t, i) {
      var o = this, s = this.backends.length, l = function P(c) {
        if (c >= s) return i(new Error("non of the backend loaded data", !0));
        var h = c === s - 1, f = o.options.handleEmptyResourcesAsFailed && !h ? 0 : -1, E = o.backends[c];
        E.read ? re(E, n, t, function(Oe, L, ee) {
          if (!Oe && L && Object.keys(L).length > f) {
            if (i(null, L, c), m(c - 1, L), E.save && o.options.cacheHitMode && ["refresh", "refreshAndUpdateStore"].indexOf(o.options.cacheHitMode) > -1) {
              if (ee && o.options.refreshExpirationTime && ee + o.options.refreshExpirationTime > Date.now()) return;
              var H = o.backends[c + 1];
              H && H.read && re(H, n, t, function(ve, y) {
                ve || y && (Object.keys(y).length <= f || (m(c, y), o.options.cacheHitMode === "refreshAndUpdateStore" && o.services && o.services.resourceStore && o.services.resourceStore.addResourceBundle(n, t, y)));
              });
            }
          } else
            P(c + 1);
        }) : P(c + 1);
      }, m = function P(c, h) {
        if (!(c < 0)) {
          var f = o.backends[c];
          f.save && f.save(n, t, h), P(c - 1, h);
        }
      };
      l(0);
    }
  }, {
    key: "create",
    value: function(n, t, i, o) {
      var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {
      }, l = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      this.backends.forEach(function(m) {
        if (m.create) {
          var P = m.create.bind(m);
          if (P.length < 6) {
            try {
              var c;
              P.length === 5 ? c = P(n, t, i, o, l) : c = P(n, t, i, o), c && typeof c.then == "function" ? c.then(function(h) {
                return s(null, h);
              }).catch(s) : s(null, c);
            } catch (h) {
              s(h);
            }
            return;
          }
          P(n, t, i, o, s, l);
        }
      });
    }
  }, {
    key: "reload",
    value: function() {
      var n = this, t = this.services, i = t.backendConnector, o = t.languageUtils, s = t.logger, l = i.language;
      if (!(l && l.toLowerCase() === "cimode")) {
        var m = [], P = function(h) {
          var f = o.toResolveHierarchy(h);
          f.forEach(function(E) {
            m.indexOf(E) < 0 && m.push(E);
          });
        };
        P(l), this.allOptions.preload && this.allOptions.preload.forEach(function(c) {
          return P(c);
        }), m.forEach(function(c) {
          n.allOptions.ns.forEach(function(h) {
            i.read(c, h, "read", null, null, function(f, E) {
              f && s.warn("loading namespace ".concat(h, " for language ").concat(c, " failed"), f), !f && E && s.log("loaded namespace ".concat(h, " for language ").concat(c), E), i.loaded("".concat(c, "|").concat(h), f, E);
            });
          });
        });
      }
    }
  }]), e;
}();
Ee.type = "backend";
var ha = function(a) {
  return {
    type: "backend",
    init: function(t, i, o) {
    },
    read: function(t, i, o) {
      if (typeof a == "function") {
        if (a.length < 3) {
          try {
            var s = a(t, i);
            s && typeof s.then == "function" ? s.then(function(l) {
              return o(null, l && l.default || l);
            }).catch(o) : o(null, s);
          } catch (l) {
            o(l);
          }
          return;
        }
        a(t, i, o);
        return;
      }
      o(null, a && a[t] && a[t][i]);
    }
  };
};
const ma = {
  i386: "iPhone Simulator",
  x86_64: "iPhone Simulator",
  arm64: "iPhone Simulator",
  "iPhone1,1": "iPhone",
  "iPhone1,2": "iPhone 3G",
  "iPhone2,1": "iPhone 3GS",
  "iPhone3,1": "iPhone 4",
  "iPhone3,2": "iPhone 4 GSM Rev A",
  "iPhone3,3": "iPhone 4 CDMA",
  "iPhone4,1": "iPhone 4S",
  "iPhone5,1": "iPhone 5 (GSM)",
  "iPhone5,2": "iPhone 5 (GSM+CDMA)",
  "iPhone5,3": "iPhone 5C (GSM)",
  "iPhone5,4": "iPhone 5C (Global)",
  "iPhone6,1": "iPhone 5S (GSM)",
  "iPhone6,2": "iPhone 5S (Global)",
  "iPhone7,1": "iPhone 6 Plus",
  "iPhone7,2": "iPhone 6",
  "iPhone8,1": "iPhone 6s",
  "iPhone8,2": "iPhone 6s Plus",
  "iPhone8,4": "iPhone SE (GSM)",
  "iPhone9,1": "iPhone 7",
  "iPhone9,2": "iPhone 7 Plus",
  "iPhone9,3": "iPhone 7",
  "iPhone9,4": "iPhone 7 Plus",
  "iPhone10,1": "iPhone 8",
  "iPhone10,2": "iPhone 8 Plus",
  "iPhone10,3": "iPhone X Global",
  "iPhone10,4": "iPhone 8",
  "iPhone10,5": "iPhone 8 Plus",
  "iPhone10,6": "iPhone X GSM",
  "iPhone11,2": "iPhone XS",
  "iPhone11,4": "iPhone XS Max",
  "iPhone11,6": "iPhone XS Max Global",
  "iPhone11,8": "iPhone XR",
  "iPhone12,1": "iPhone 11",
  "iPhone12,3": "iPhone 11 Pro",
  "iPhone12,5": "iPhone 11 Pro Max",
  "iPhone12,8": "iPhone SE 2nd Gen",
  "iPhone13,1": "iPhone 12 Mini",
  "iPhone13,2": "iPhone 12",
  "iPhone13,3": "iPhone 12 Pro",
  "iPhone13,4": "iPhone 12 Pro Max",
  "iPhone14,2": "iPhone 13 Pro",
  "iPhone14,3": "iPhone 13 Pro Max",
  "iPhone14,4": "iPhone 13 Mini",
  "iPhone14,5": "iPhone 13",
  "iPhone14,6": "iPhone SE 3rd Gen",
  "iPhone14,7": "iPhone 14",
  "iPhone14,8": "iPhone 14 Plus",
  "iPhone15,2": "iPhone 14 Pro",
  "iPhone15,3": "iPhone 14 Pro Max",
  "iPod1,1": "1st Gen iPod",
  "iPod2,1": "2nd Gen iPod",
  "iPod3,1": "3rd Gen iPod",
  "iPod4,1": "4th Gen iPod",
  "iPod5,1": "5th Gen iPod",
  "iPod7,1": "6th Gen iPod",
  "iPod9,1": "7th Gen iPod",
  "iPad1,1": "iPad",
  "iPad1,2": "iPad 3G",
  "iPad2,1": "2nd Gen iPad",
  "iPad2,2": "2nd Gen iPad GSM",
  "iPad2,3": "2nd Gen iPad CDMA",
  "iPad2,4": "2nd Gen iPad New Revision",
  "iPad3,1": "3rd Gen iPad",
  "iPad3,2": "3rd Gen iPad CDMA",
  "iPad3,3": "3rd Gen iPad GSM",
  "iPad2,5": "iPad mini",
  "iPad2,6": "iPad mini GSM+LTE",
  "iPad2,7": "iPad mini CDMA+LTE",
  "iPad3,4": "4th Gen iPad",
  "iPad3,5": "4th Gen iPad GSM+LTE",
  "iPad3,6": "4th Gen iPad CDMA+LTE",
  "iPad4,1": "iPad Air (WiFi)",
  "iPad4,2": "iPad Air (GSM+CDMA)",
  "iPad4,3": "1st Gen iPad Air (China)",
  "iPad4,4": "iPad mini Retina (WiFi)",
  "iPad4,5": "iPad mini Retina (GSM+CDMA)",
  "iPad4,6": "iPad mini Retina (China)",
  "iPad4,7": "iPad mini 3 (WiFi)",
  "iPad4,8": "iPad mini 3 (GSM+CDMA)",
  "iPad4,9": "iPad Mini 3 (China)",
  "iPad5,1": "iPad mini 4 (WiFi)",
  "iPad5,2": "4th Gen iPad mini (WiFi+Cellular)",
  "iPad5,3": "iPad Air 2 (WiFi)",
  "iPad5,4": "iPad Air 2 (Cellular)",
  "iPad6,3": "iPad Pro (9.7 inch, WiFi)",
  "iPad6,4": "iPad Pro (9.7 inch, WiFi+LTE)",
  "iPad6,7": "iPad Pro (12.9 inch, WiFi)",
  "iPad6,8": "iPad Pro (12.9 inch, WiFi+LTE)",
  "iPad6,11": "iPad (2017)",
  "iPad6,12": "iPad (2017)",
  "iPad7,1": "iPad Pro 2nd Gen (WiFi)",
  "iPad7,2": "iPad Pro 2nd Gen (WiFi+Cellular)",
  "iPad7,3": "iPad Pro 10.5-inch 2nd Gen",
  "iPad7,4": "iPad Pro 10.5-inch 2nd Gen",
  "iPad7,5": "iPad 6th Gen (WiFi)",
  "iPad7,6": "iPad 6th Gen (WiFi+Cellular)",
  "iPad7,11": "iPad 7th Gen 10.2-inch (WiFi)",
  "iPad7,12": "iPad 7th Gen 10.2-inch (WiFi+Cellular)",
  "iPad8,1": "iPad Pro 11 inch 3rd Gen (WiFi)",
  "iPad8,2": "iPad Pro 11 inch 3rd Gen (1TB, WiFi)",
  "iPad8,3": "iPad Pro 11 inch 3rd Gen (WiFi+Cellular)",
  "iPad8,4": "iPad Pro 11 inch 3rd Gen (1TB, WiFi+Cellular)",
  "iPad8,5": "iPad Pro 12.9 inch 3rd Gen (WiFi)",
  "iPad8,6": "iPad Pro 12.9 inch 3rd Gen (1TB, WiFi)",
  "iPad8,7": "iPad Pro 12.9 inch 3rd Gen (WiFi+Cellular)",
  "iPad8,8": "iPad Pro 12.9 inch 3rd Gen (1TB, WiFi+Cellular)",
  "iPad8,9": "iPad Pro 11 inch 4th Gen (WiFi)",
  "iPad8,10": "iPad Pro 11 inch 4th Gen (WiFi+Cellular)",
  "iPad8,11": "iPad Pro 12.9 inch 4th Gen (WiFi)",
  "iPad8,12": "iPad Pro 12.9 inch 4th Gen (WiFi+Cellular)",
  "iPad11,1": "iPad mini 5th Gen (WiFi)",
  "iPad11,2": "iPad mini 5th Gen",
  "iPad11,3": "iPad Air 3rd Gen (WiFi)",
  "iPad11,4": "iPad Air 3rd Gen",
  "iPad11,6": "iPad 8th Gen (WiFi)",
  "iPad11,7": "iPad 8th Gen (WiFi+Cellular)",
  "iPad12,1": "iPad 9th Gen (WiFi)",
  "iPad12,2": "iPad 9th Gen (WiFi+Cellular)",
  "iPad14,1": "iPad mini 6th Gen (WiFi)",
  "iPad14,2": "iPad mini 6th Gen (WiFi+Cellular)",
  "iPad13,1": "iPad Air 4th Gen (WiFi)",
  "iPad13,2": "iPad Air 4th Gen (WiFi+Cellular)",
  "iPad13,4": "iPad Pro 11 inch 5th Gen",
  "iPad13,5": "iPad Pro 11 inch 5th Gen",
  "iPad13,6": "iPad Pro 11 inch 5th Gen",
  "iPad13,7": "iPad Pro 11 inch 5th Gen",
  "iPad13,8": "iPad Pro 12.9 inch 5th Gen",
  "iPad13,9": "iPad Pro 12.9 inch 5th Gen",
  "iPad13,10": "iPad Pro 12.9 inch 5th Gen",
  "iPad13,11": "iPad Pro 12.9 inch 5th Gen",
  "iPad13,16": "iPad Air 5th Gen (WiFi)",
  "iPad13,17": "iPad Air 5th Gen (WiFi+Cellular)",
  "iPad13,18": "iPad 10th Gen",
  "iPad13,19": "iPad 10th Gen",
  "iPad14,3": "iPad Pro 11 inch 4th Gen",
  "iPad14,4": "iPad Pro 11 inch 4th Gen",
  "iPad14,5": "iPad Pro 12.9 inch 6th Gen",
  "iPad14,6": "iPad Pro 12.9 inch 6th Gen",
  "Watch1,1": "Apple Watch 38mm case",
  "Watch1,2": "Apple Watch 42mm case",
  "Watch2,6": "Apple Watch Series 1 38mm case",
  "Watch2,7": "Apple Watch Series 1 42mm case",
  "Watch2,3": "Apple Watch Series 2 38mm case",
  "Watch2,4": "Apple Watch Series 2 42mm case",
  "Watch3,1": "Apple Watch Series 3 38mm case (GPS+Cellular)",
  "Watch3,2": "Apple Watch Series 3 42mm case (GPS+Cellular)",
  "Watch3,3": "Apple Watch Series 3 38mm case (GPS)",
  "Watch3,4": "Apple Watch Series 3 42mm case (GPS)",
  "Watch4,1": "Apple Watch Series 4 40mm case (GPS)",
  "Watch4,2": "Apple Watch Series 4 44mm case (GPS)",
  "Watch4,3": "Apple Watch Series 4 40mm case (GPS+Cellular)",
  "Watch4,4": "Apple Watch Series 4 44mm case (GPS+Cellular)",
  "Watch5,1": "Apple Watch Series 5 40mm case (GPS)",
  "Watch5,2": "Apple Watch Series 5 44mm case (GPS)",
  "Watch5,3": "Apple Watch Series 5 40mm case (GPS+Cellular)",
  "Watch5,4": "Apple Watch Series 5 44mm case (GPS+Cellular)",
  "Watch5,9": "Apple Watch SE 40mm case (GPS)",
  "Watch5,10": "Apple Watch SE 44mm case (GPS)",
  "Watch5,11": "Apple Watch SE 40mm case (GPS+Cellular)",
  "Watch5,12": "Apple Watch SE 44mm case (GPS+Cellular)",
  "Watch6,1": "Apple Watch Series 6 40mm case (GPS)",
  "Watch6,2": "Apple Watch Series 6 44mm case (GPS)",
  "Watch6,3": "Apple Watch Series 6 40mm case (GPS+Cellular)",
  "Watch6,4": "Apple Watch Series 6 44mm case (GPS+Cellular)",
  "Watch6,6": "Apple Watch Series 7 41mm case (GPS)",
  "Watch6,7": "Apple Watch Series 7 45mm case (GPS)",
  "Watch6,8": "Apple Watch Series 7 41mm case (GPS+Cellular)",
  "Watch6,9": "Apple Watch Series 7 45mm case (GPS+Cellular)",
  "Watch6,10": "Apple Watch SE 40mm case (GPS)",
  "Watch6,11": "Apple Watch SE 44mm case (GPS)",
  "Watch6,12": "Apple Watch SE 40mm case (GPS+Cellular)",
  "Watch6,13": "Apple Watch SE 44mm case (GPS+Cellular)",
  "Watch6,14": "Apple Watch Series 8 41mm case (GPS)",
  "Watch6,15": "Apple Watch Series 8 45mm case (GPS)",
  "Watch6,16": "Apple Watch Series 8 41mm case (GPS+Cellular)",
  "Watch6,17": "Apple Watch Series 8 45mm case (GPS+Cellular)",
  "Watch6,18": "Apple Watch Ultra"
}, Pa = {
  data: ma
}, Sa = {
  assign: "Activate card",
  cancel: "Cancel",
  continue: "Continue",
  again: "Try again",
  agree: "Agree",
  decline: "Decline",
  login: "Close and log in"
}, fa = {
  "header-line-1": "That proximity card isn't activated",
  "header-line-2": "Activate it now",
  "awesome-msg": "Awesome! You can use your card."
}, pa = {
  "caps-lock-tooltip": "CAPS LOCK is on",
  title: "Enter your password"
}, Ea = {
  loading: "Loading...",
  "primary-text": "Login to Hyperspace",
  username: {
    username: "Username",
    label: "Enter username",
    "custom-label": "Enter your {{username}}"
  },
  password: {
    password: "Password",
    label: "Enter your network password",
    "facial-label": "Password",
    "custom-label": "Enter your {{password}}",
    "change-username-button": "Change"
  },
  proxcard: {
    label: "Tap your proximity card",
    "custom-label": "Tap your {{card}}"
  },
  pin: {
    label: "Enter your PIN",
    "custom-label": "Enter your {{pin}}"
  },
  token: {
    label: "Enter the code from your",
    "label-1": "Enter the",
    "label-2": "from your",
    "label-btn": "code",
    "input-placeholder": "Imprivata Token Code"
  },
  push: {
    info: "Approve on your",
    "not-notified": "Didn't get notified?",
    "try-again": "Try again",
    "use-another": "Use another method"
  },
  "logout-successful": "You successfully logged out.",
  "logout-due-invalid-session": "Session invalid.",
  "internal-error": "An unexpected problem occurred.",
  autologin: {
    "no-session-or-tenant-id": "No session id or tenant id provided for autologin"
  }
}, Ia = {
  "getting-started": {
    title: "Enroll your face",
    "body-text": "you are about to begin enrolling your face to use for quick and easy authentication"
  },
  auth: {
    authenticating: "Authenticating"
  }
}, Aa = {
  "step-1": {
    header: "Biometric consent",
    text: "Biometric data regulations vary based on many factors, including jurisdiction. If you reside in the U.S., select your U.S. state below, or if you are not a U.S. resident, select your location.",
    "text-2": "If consent is required, it will be requested on the following screen."
  },
  "screen-2-title": "Your residence: {{state}}",
  "state-picker-label": "Select one",
  decline: "Decline consent",
  "resident-decline": "Do this later",
  "decline-modal": {
    title: "Consent required",
    text: "Your facial biometric will be deleted if you decline consent",
    "go-back-and-grant": "Go back and grant consent"
  }
}, Na = {
  IMAGE_ALT: "No Authentication Factors Available",
  "something-unexpected": `An unexpected problem occurred. 
We are working to resolve it.`,
  "something-not-right": "Something's not right.",
  "invalid-credentials": "Could not authenticate you. Try again.",
  "other-error": "Could not authenticate you. Try again.",
  "user-not-found": "User not found",
  "account-disabled": "Your Azure AD account is disabled. Contact your help desk.",
  "session-expired": "Session expired",
  "unknown-auth-method": "Unknown authentication method: {{method}}",
  "authentication-failed": "Authentication failed",
  "incorrect-tenant-id": "The Tenant ID is not valid. Please see your administrator.",
  "tenant-id-not-provided": "No Tenant ID provided.",
  "no-permission": "You do not have proper permission.",
  "unknown-error": "An unexpected problem occurred.",
  "no-factor": {
    1: "You haven't added the required authentication methods.",
    2: ", or contact your help desk.",
    btn: "Add authentication methods now"
  },
  "epcs-username-not-found": {
    1: "To correct this:",
    2: "1. Log OUT of Epic Hyperdrive",
    3: "2. Log IN to Epic Hyperdrive using Imprivata to allow Imprivata to learn your Epic User ID.",
    title: "Unable to complete order signing."
  },
  "no-face-detected": "User not recognized",
  "low-quality": "User not recognized",
  "face-limit": "Multiple faces in the image",
  duplicate: "Face matches with existing user",
  liveness: "Liveness check failed",
  realness: "Realness check failed",
  fatal: "An unexpected problem occurred.",
  INCORRECT_USER_ID: "The user ID is not valid. Please see your administrator.",
  INCORRECT_USER_NAME: "Incorrect username",
  INSUFFICIENT_FACTOR_OPTIONS: "Insufficient Factors available for authentication",
  INCORRECT_PASSWORD: "Could not authenticate you. Try again.",
  SESSION_ERROR: "Error establishing session.",
  INCORRECT_TENANT_ID: "The Tenant ID is not valid, Please see your administrator.",
  MISSING_QUERY_PARAMS: "Missing required query params - tenantId, contextType or resourceType",
  SESSION_EXPIRED: "Session expired",
  FATAL_ERROR: "An unexpected problem occurred.",
  NETWORK_ERROR: "Could not process the request due to a network error. Try again.",
  NOT_ENROLLED_CARD: "Prox card not enrolled",
  NOT_FOUND: "Username not found",
  CREDENTIAL_EXPIRED: "Your password has expired and must be changed.",
  "credential-expired": "Your password has expired and must be changed.",
  ACCOUNT_DISABLED: "Your Azure AD account is disabled. Contact your help desk.",
  "idp-disabled": "Your Azure AD account is disabled. Contact your help desk.",
  "idp-locked": "Your Azure AD account is locked. Contact your help desk.",
  PUSH_NOTIFICATION_EXPIRED: "Push notification expired",
  UXID_MULTIPLEUSERS: "Could not authenticate you. Try again using your full {{username}}. (Example: jsmith@maguirehealth.org)",
  "ambiguous-username": "Could not authenticate you. Try again using your full {{username}}. (Example: jsmith@maguirehealth.org)",
  UXID_AUTH_BADTOKENPASSCODE: "Enter the correct Imprivata ID token code",
  "network-error": "No network connection.",
  offline: "No network connection.",
  "offline-sub-message": "Limited functionality available."
}, ga = "Loading", Ta = {
  actions: Sa,
  enroll: fa,
  "factor-switch": {
    "primary-btn": "Use another method",
    "add-method-btn": "Add method"
  },
  password: pa,
  login: Ea,
  face: Ia,
  consent: Aa,
  errors: Na,
  loading: ga
}, Ra = {
  assign: "Asignar",
  cancel: "Cancelar",
  continue: "Continuar"
}, ba = {
  "header-line-1": "Parece que esa tarjeta de proximidad no está asignada a nadie.",
  "header-line-2": "Si lo asigna ahora, puede usarlo para iniciar sesión con un simple toque.",
  "awesome-msg": "¡Impresionante! Puedes usar tu tarjeta"
}, _a = {
  "caps-lock-tooltip": "MAYUSCULAS esta activado",
  title: "Ingrese su contraseña"
}, Oa = {
  loading: "Cargando...",
  "primary-text": "Iniciar sesión en Hyperspace",
  username: {
    label: "Ingrese su nombre de usuario",
    "custom-label": "Ingrese su {{username}}"
  },
  password: {
    label: "Ingrese su contraseña de red",
    "custom-label": "Ingrese su {{password}}"
  },
  proxcard: {
    label: "Toca tu tarjeta de proximidad",
    "custom-label": "Toca tu {{card}}"
  },
  "logout-successful": "Has cerrado sesión correctamente.",
  "logout-due-invalid-session": "Sesión inválida.",
  "internal-error": "Ocurrió un problema inesperado.",
  autologin: {
    "no-session-or-tenant-id": "No se proporcionó una identificación de sesión o una identificación de inquilino para el inicio de sesión automático"
  }
}, va = {
  auth: {
    authenticating: "Autenticando a"
  }
}, Ca = {
  IMAGE_ALT: "No hay factores de autenticación disponibles",
  "something-unexpected": `Algo muy, muy inesperado sucedió. Estamos trabajando en ello, pero, si lo necesitas, consulta. 
Estamos trabajando para solucionarlo.`,
  "user-invalid-credentials": "No se pudo autenticar. Intentar otra vez.",
  "user-not-found": "Usuario no encontrado",
  "password-expired": "Su contraseña ha caducado y debe cambiarse.",
  "account-disabled": "Su cuenta de Azure AD está deshabilitada. Porfavor contactar servicio al cliente.",
  "session-expired": "Sesión expirada",
  "unknown-auth-method": "Método de autenticación desconocido: {{method}}",
  "authentication-failed": "Autenticación fallida",
  "incorrect-tenant-id": "El ID de inquilino no es válido. Consulte a su administrador.",
  "tenant-id-not-provided": "No se proporcionó una identificación de inquilino.",
  "no-permission": "No tienes el permiso adecuado.",
  fatal: "Ocurrió un problema inesperado.",
  INCORRECT_USER_ID: "El ID de usuario no es válido. Consulte a su administrador.",
  INCORRECT_USER_NAME: "Nombre de usuario incorrecto",
  INSUFFICIENT_FACTOR_OPTIONS: "Factores insuficientes disponibles para la autenticación",
  INCORRECT_PASSWORD: "No se pudo autenticar. Intentar otra vez.",
  SESSION_ERROR: "Error al establecer sesión.",
  INCORRECT_TENANT_ID: "El ID de inquilino no es válido, consulte a su administrador.",
  MISSING_QUERY_PARAMS: "Faltan los parámetros de consulta necesarios: TenantId, contextType o resourceType",
  SESSION_EXPIRED: "Sesión expirada",
  FATAL_ERROR: "Ocurrió un problema inesperado.",
  NOT_ENROLLED_CARD: "Tarjeta Prox no inscrita",
  CREDENTIAL_EXPIRED: "Su contraseña ha caducado y debe cambiarse.",
  ACCOUNT_DISABLED: "Su cuenta de Azure AD está deshabilitada. Porfavor contactar servicio al cliente.",
  UXID_MULTIPLEUSERS: "No se pudo autenticar. Vuelva a intentarlo con su nombre de usuario completo. (Ejemplo: jsmith@maguirehealth.org)"
}, Da = "Cargando", La = {
  actions: Ra,
  enroll: ba,
  password: _a,
  login: Oa,
  face: va,
  errors: Ca,
  loading: Da
}, Ie = { en: ke }, ya = ({
  fallback: e,
  children: a
}) => /* @__PURE__ */ U(Ge, { fallback: e || /* @__PURE__ */ U(Ve, {}), children: /* @__PURE__ */ U(we, { i18n: D, defaultNS: R, children: /* @__PURE__ */ U(Fe, { locale: Ie[D.language || "en"], children: a }) }) });
var Ae = /* @__PURE__ */ ((e) => (e.TRANSLATION = "translation", e.DEVICE_MODEL = "deviceModel", e))(Ae || {});
const R = "translation", $ = "deviceModel", Ne = {
  en: { [R]: Ta, [$]: Pa },
  es: { [R]: La }
}, ge = [R, $], D = Le.createInstance({
  debug: !1,
  defaultNS: R,
  ns: ge,
  lng: "en",
  fallbackLng: "en",
  returnEmptyString: !1,
  backend: {
    backends: [
      // Load translations from json files in ./translations
      ha(Ne)
    ]
  },
  detection: { order: ["querystring", "navigator"], lookupQuerystring: "lng" },
  react: { useSuspense: !0 }
});
D.use(Ue).use(Ee).use(fe).init();
const nn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LocaleProvider: ya,
  TranslateNS: Ae,
  antLocales: Ie,
  default: D,
  defaultNS: R,
  deviceModelNS: $,
  i18n: D,
  ns: ge,
  resources: Ne
}, Symbol.toStringTag, { value: "Module" })), tn = 720, on = 580, wa = {
  TENANT_ID: "tenantId",
  CONTEXT_TYPE: "contextType",
  RESOURCE_TYPE: "resourceType",
  APP_ID: "applicationId",
  // for testing
  CIPHER_V2: "cipherV2",
  SHOW_ADD_METHOD: "showAddMethod",
  // Customizing face auth
  MAX_ENROLL_WIDTH: "maxEnrollWidth",
  SHOW_VIDEO: "showVideo"
}, sn = 30, rn = [
  "mousemove",
  "keydown",
  "wheel",
  "mousewheel",
  "mousedown",
  "touchstart"
];
var Ua = /* @__PURE__ */ ((e) => (e.SUCCESS = "success", e.FAILED = "failed", e))(Ua || {}), Wa = /* @__PURE__ */ ((e) => (e.Authenticating = "Authenticating", e.Enrolling = "Enrolling", e))(Wa || {});
const ln = ["input"], cn = {
  SUBMIT_CONSENT: "submit-consent"
}, un = [
  { value: "AL", label: "AL - Alabama", titleLabel: "Alabama" },
  { value: "AK", label: "AK - Alaska", titleLabel: "Alaska" },
  { value: "AS", label: "AS - American Samoa", titleLabel: "American Samoa" },
  { value: "AZ", label: "AZ - Arizona", titleLabel: "Arizona" },
  { value: "AR", label: "AR - Arkansas", titleLabel: "Arkansas" },
  { value: "CA", label: "CA - California", titleLabel: "California" },
  { value: "CO", label: "CO - Colorado", titleLabel: "Colorado" },
  { value: "CT", label: "CT - Connecticut", titleLabel: "Connecticut" },
  { value: "DE", label: "DE - Delaware", titleLabel: "Delaware" },
  { value: "DC", label: "DC - District of Columbia", titleLabel: "District of Columbia" },
  { value: "FL", label: "FL - Florida", titleLabel: "Florida" },
  { value: "GA", label: "GA - Georgia", titleLabel: "Georgia" },
  { value: "GU", label: "GU - Guam", titleLabel: "Guam" },
  { value: "HI", label: "HI - Hawaii", titleLabel: "Hawaii" },
  { value: "ID", label: "ID - Idaho", titleLabel: "Idaho" },
  { value: "IL", label: "IL - Illinois", titleLabel: "Illinois" },
  { value: "IN", label: "IN - Indiana", titleLabel: "Indiana" },
  { value: "IA", label: "IA - Iowa", titleLabel: "Iowa" },
  { value: "KS", label: "KS - Kansas", titleLabel: "Kansas" },
  { value: "KY", label: "KY - Kentucky", titleLabel: "Kentucky" },
  { value: "LA", label: "LA - Louisiana", titleLabel: "Louisiana" },
  { value: "ME", label: "ME - Maine", titleLabel: "Maine" },
  { value: "MD", label: "MD - Maryland", titleLabel: "Maryland" },
  { value: "MA", label: "MA - Massachusetts", titleLabel: "Massachusetts" },
  { value: "MI", label: "MI - Michigan", titleLabel: "Michigan" },
  { value: "MN", label: "MN - Minnesota", titleLabel: "Minnesota" },
  { value: "MS", label: "MS - Mississippi", titleLabel: "Mississippi" },
  { value: "MO", label: "MO - Missouri", titleLabel: "Missouri" },
  { value: "MT", label: "MT - Montana", titleLabel: "Montana" },
  { value: "NE", label: "NE - Nebraska", titleLabel: "Nebraska" },
  { value: "NV", label: "NV - Nevada", titleLabel: "Nevada" },
  { value: "NH", label: "NH - New Hampshire", titleLabel: "New Hampshire" },
  { value: "NJ", label: "NJ - New Jersey", titleLabel: "New Jersey" },
  { value: "NM", label: "NM - New Mexico", titleLabel: "New Mexico" },
  { value: "NY", label: "NY - New York", titleLabel: "New York" },
  { value: "NC", label: "NC - North Carolina", titleLabel: "North Carolina" },
  { value: "ND", label: "ND - North Dakota", titleLabel: "North Dakota" },
  { value: "MP", label: "MP - Northern Mariana Islands", titleLabel: "Northern Mariana Islands" },
  { value: "OH", label: "OH - Ohio", titleLabel: "Ohio" },
  { value: "OK", label: "OK - Oklahoma", titleLabel: "Oklahoma" },
  { value: "OR", label: "OR - Oregon", titleLabel: "Oregon" },
  { value: "PA", label: "PA - Pennsylvania", titleLabel: "Pennsylvania" },
  { value: "PR", label: "PR - Puerto Rico", titleLabel: "Puerto Rico" },
  { value: "RI", label: "RI - Rhode Island", titleLabel: "Rhode Island" },
  { value: "SC", label: "SC - South Carolina", titleLabel: "South Carolina" },
  { value: "SD", label: "SD - South Dakota", titleLabel: "South Dakota" },
  { value: "TN", label: "TN - Tennessee", titleLabel: "Tennessee" },
  { value: "TX", label: "TX - Texas", titleLabel: "Texas" },
  { value: "UT", label: "UT - Utah", titleLabel: "Utah" },
  { value: "VT", label: "VT - Vermont", titleLabel: "Vermont" },
  { value: "VA", label: "VA - Virginia", titleLabel: "Virginia" },
  { value: "VI", label: "VI - Virgin Islands", titleLabel: "Virgin Islands" },
  { value: "WA", label: "WA - Washington", titleLabel: "Washington" },
  { value: "WV", label: "WV - West Virginia", titleLabel: "West Virginia" },
  { value: "WI", label: "WI - Wisconsin", titleLabel: "Wisconsin" },
  { value: "WY", label: "WY - Wyoming", titleLabel: "Wyoming" },
  { value: "UK", label: "United Kingdom", titleLabel: "United Kingdom" },
  { value: "CANADA", label: "Canada", titleLabel: "Canada" },
  { value: "EEU", label: "European Economic Area", titleLabel: "European Economic Area" },
  { value: "OTHER", label: "Other", titleLabel: "Other" }
], Fa = {
  [S.StrictTransportSecurity]: "max-age=86400;includeSubDomains",
  [S.XSSProtection]: "1;mode=block",
  [S.XFrameOptions]: "DENY",
  [S.XContentTypeOptions]: "nosniff"
}, u = Xe.create({ withCredentials: !0, headers: Fa }), ka = {
  [S.StrictTransportSecurity]: "max-age=86400;includeSubDomains",
  [S.XSSProtection]: "1;mode=block",
  [S.XFrameOptions]: "DENY",
  [S.XContentTypeOptions]: "nosniff"
}, Ga = async (e, { credentials: a, ...n }, t = !0) => (ae.request({ url: e, method: n.method }), fetch(e, {
  ...n,
  credentials: a,
  headers: { ...t && ka, ...n.headers || {} }
}).then(async (i) => {
  if (i.ok)
    return i.json();
  const o = await i.json().then((s) => s);
  return Promise.reject(o.error);
}).catch((i) => {
  const o = `Error fetching data from ${e} with error: ${i}`;
  return ae.log(o), Promise.reject(i);
})), Te = ce(), { API_URL: p, METADATA_URL: Ma } = Te;
ue("[Authn] appConfig: ", Te);
function g(e) {
  return e && "data" in e ? e.data : e;
}
function I() {
  return ce().AUTHN_API_VERSION;
}
function Re() {
  W(S.StrictTransportSecurity, "max-age=86400;includeSubDomains"), W(S.XSSProtection, "1;mode=block"), W(S.XFrameOptions, "DENY"), W(S.XContentTypeOptions, "nosniff"), u != null && u.defaults && (u.defaults.withCredentials = !0);
}
const xa = async (e) => {
  if (e) {
    const a = await Ye(`${Ma}/data-privacy/public.json`);
    return ne.createContextV2(a.key, a.version);
  }
  return ne.createContextV1();
};
async function dn(e) {
  Re();
  const n = `${p}/authn-web/authn/${I()}/next-factors/get`, t = await u.post(n, e);
  return g(t);
}
const hn = Me(
  xe(He.API, "create-session"),
  async (e, a, n) => {
    Ha(S.ImprSessionId);
    const t = !!new URLSearchParams(window.location.search).has(wa.CIPHER_V2), i = { encode: await xa(t) }, o = {
      headers: {
        [S.ImprCodingCtx]: i.encode.buildImprCodingCtxHeader(),
        ...(n == null ? void 0 : n.headers) || {}
      }
    }, s = a ? `${p}/authn-web/enroll/${I()}/enroll-session/start` : `${p}/authn-web/authn/${I()}/authn-session/start`, l = await u.post(`${s}`, e, o);
    return { session: i, response: g(l) };
  }
);
async function mn(e, a, n, t) {
  const i = n ? `${p}/authn-web/enroll/${I()}/enrollee/authenticate` : `${p}/authn-web/authn/${I()}/authenticate`, o = F(e.factorData), s = F(e.systemData);
  console.debug("[AuthApi] authenticate", i);
  const l = await u.post(
    i,
    {
      ...e,
      factorData: a.encode.encryptJson(o),
      systemData: a.encode.encryptJson(s)
    },
    t
  );
  return { session: a, response: g(l) };
}
async function Pn(e) {
  const a = `${p}/authn-web/authn/${I()}/authenticate/by-enrollment-session`, n = await u.post(a, void 0, e);
  return g(n);
}
const Sn = async ({
  factorType: e,
  username: a,
  authnContext: n,
  applicationId: t
}) => {
  const i = await u.post(
    `${p}/authn-web/enrollment-factor/v1/check-factor`,
    { factorType: e, username: a, authnContext: n, applicationId: t }
  );
  return g(i);
};
async function fn(e, a) {
  Re();
  const n = `${p}/authn-web/enroll/${I()}/enroll`, t = F(e.factorData), i = F(e.systemData), o = u.post(n, {
    ...e,
    factorData: a.encode.encryptJson(t),
    systemData: a.encode.encryptJson(i)
  });
  return g(o);
}
async function pn(e) {
  return await Ga(
    e,
    { method: "GET", credentials: "omit" },
    !1
  );
}
const En = async (e) => {
  await u.post(
    `${p}/authn-web/user-consent/v1/consent/submit`,
    e
  );
};
async function In() {
  const e = await u.post(
    `${p}/authn-web/authn/${I()}/push-authn-status/get`,
    { factorType: v.IMPR_ID }
  );
  return g(e);
}
async function An(e, a) {
  var t, i;
  const n = {
    ...(i = (t = u == null ? void 0 : u.defaults) == null ? void 0 : t.headers) == null ? void 0 : i.common,
    // "Context-Type" is case sensitive to match the key and override the value in client.defaults.headers.common
    "Content-Type": "application/json",
    ...(a == null ? void 0 : a.headers) || {}
  };
  return fetch(`${p}/authn-web/authn/${I()}/authn-session/terminate`, {
    headers: n,
    keepalive: !0,
    body: JSON.stringify({ reasonCode: e }),
    method: "POST",
    mode: "cors",
    credentials: "include"
  }).then((o) => ({}));
}
function W(e, a) {
  var n;
  (n = u == null ? void 0 : u.defaults) != null && n.headers && (u.defaults.headers.common[e] = encodeURI(a));
}
function Ha(e) {
  var a;
  (a = u == null ? void 0 : u.defaults) != null && a.headers && delete u.defaults.headers.common[e];
}
const Ya = 500, le = [502, 503, 504];
var be = /* @__PURE__ */ ((e) => (e.APP = "app", e.SYSTEM = "system", e))(be || {});
function Xa(e) {
  return (e || {}).error !== void 0;
}
function Nn(e) {
  if (Xa(e))
    return !0;
  const a = e;
  return a && typeof a == "object" ? a.code !== void 0 || a.message !== void 0 : !1;
}
var Y = /* @__PURE__ */ ((e) => (e.AUTHENTICATED = "authenticated", e.SUCCESS = "success", e.FAILURE = "failure", e.ENROLLED = "enrolled", e.FACTORS = "factors", e.SESSION = "session", e.READY = "ready", e.NOT_READY = "not-ready", e.CANCEL = "cancel", e.TERMINATE_SESSION = "terminate-session", e.ERROR = "error", e.NOT_AVAILABLE = "not-available", e.IMPR_ID_ERROR = "iid-error", e.INITIALIZED = "initialized", e.OFFLINE = "offline", e.ONLINE = "online", e.NOT_ENROLLED = "not-enrolled", e.TIMEOUT = "timeout", e.NO_SESSION = "no-session", e.SESSION_FAILED = "session-failed", e.INTERNAL_RESTART = "internal-restart", e.INTERNAL_ERROR = "internal-error", e.START_ENROLLING = "start_enrolling", e.RESTART_STATE = "restart-state", e.START_AUTHENTICATING = "start_authenticating", e.FINISH_AUTHENTICATING = "finish_authenticating", e.CAMERA_IN_USE = "camera-in-use", e))(Y || {}), d = /* @__PURE__ */ ((e) => (e.NOT_ENROLLED_CARD = "NOT_ENROLLED_CARD", e.CREDENTIAL_EXPIRED = "CREDENTIAL_EXPIRED", e.SESSION_EXPIRED = "SESSION_EXPIRED", e.SESSION_ERROR = "SESSION_ERROR", e.INCORRECT_TENANT_ID = "INCORRECT_TENANT_ID", e.PUSH_NOTIFICATION_EXPIRED = "PUSH_NOTIFICATION_EXPIRED", e.PUSH_NOTIFICATION_NOT_ALLOWED = "PUSH_NOTIFICATION_NOT_ALLOWED", e.PUSH_NOTIFICATION_REJECTED = "PUSH_NOTIFICATION_REJECTED", e.ACCOUNT_DISABLED = "ACCOUNT_DISABLED", e.INSUFFICIENT_FACTOR_OPTIONS = "INSUFFICIENT_FACTOR_OPTIONS", e.UXID_MULTIPLEUSERS = "UXID_MULTIPLEUSERS", e.NETWORK_ERROR = "NETWORK_ERROR", e.INCORRECT_PASSWORD = "INCORRECT_PASSWORD", e.INCORRECT_USER_ID = "INCORRECT_USER_ID", e.INCORRECT_USER_NAME = "INCORRECT_USER_NAME", e.UXID_AUTH_BADTOKENPASSCODE = "UXID_AUTH_BADTOKENPASSCODE", e.MISSING_QUERY_PARAMS = "MISSING_QUERY_PARAMS", e.SYSTEM_ERROR = "SYSTEM_ERROR", e.FATAL_ERROR = "FATAL_ERROR", e.OFFLINE = "OFFLINE", e.NO_HEALTHY_UPSTREAM = "no healthy upstream", e.INVALID_TENANT_ID = "INVALID_TENANT_ID", e))(d || {}), r = /* @__PURE__ */ ((e) => (e.AUTHENTICATOR_NOT_ENROLLED = "authenticator-not-enrolled", e.SESSION_EXPIRED = "session-expired", e.INVALID_SESSION_ID = "invalid-session-id", e.CREDENTIAL_EXPIRED = "credential-expired", e.ACCOUNT_DISABLED = "idp-disabled", e.ACCOUNT_LOCKED = "idp-locked", e.PUSH_REJECTED = "rejected", e.GENERIC_FACE_AUTHENTICATION_ERROR_WITHOUT_BANNER = "generic-face-authentication-error-without-banner", e.AMBIGUOUS_USERNAME = "ambiguous-username", e.INVALID_CREDENTIALS = "invalid-credentials", e.PUSH_NOTIFICATION_NOT_ALLOWED = "push-notification-not-allowed", e.NO_FACE_DETECTED = "no-face-detected", e.LOW_QUALITY = "low-quality", e.FACE_LIMIT = "face-limit", e.DUPLICATE = "duplicate", e.USER_NOT_FOUND = "user-not-found", e.LIVENESS_FAILED = "liveness", e.REALNESS_FAILED = "realness", e.OFFLINE = "offline", e.TERMINATE_CANCEL = "terminate-cancel", e.TERIMINATE_TIMEOUT = "terminate-timeout", e.INVALID_TOKEN = "other-error", e.NETWORK_ERROR = "network-error", e.FACTORS_INSUFFICIENT = "factors-insufficient", e.PERMISSION_DENIED = "forbidden", e.NOT_FOUND = "not-found", e.INVALID_TENANT_ID = "invalid-tenant-id", e.FAILED_PRECONDITION = "FAILED_PRECONDITION", e.INTERNAL = "INTERNAL", e.UNKNOWN = "unknown-error", e.SYSTEM_ERROR = "system-error", e.SESSION_NOT_FOUND = "session-not-found", e.BAD_REQUEST = "bad-request", e.ARG_VALIDATION_FAILED = "argument-validation-falied", e.IMPLEMENTATION_DEFECT = "implementation-defect", e.ERR_BAD_REQUEST = "ERR_BAD_REQUEST", e.ERR_NETWORK = "ERR_NETWORK", e.CAMERA_IN_USE = "camera-in-use", e))(r || {});
const gn = [
  "low-quality",
  "face-limit",
  "offline",
  "network-error",
  "camera-in-use"
  /* CAMERA_IN_USE */
], Tn = [
  "no-face-detected"
  /* NO_FACE_DETECTED */
], Rn = [
  "credential-expired"
  /* CREDENTIAL_EXPIRED */
], x = class x extends Error {
  constructor(n, t) {
    super((n == null ? void 0 : n.message) || (n == null ? void 0 : n.code) || d.SYSTEM_ERROR);
    w(this, "details");
    w(this, "params");
    w(this, "code");
    this.details = n instanceof x ? n.details : n, this.params = t || n.params, this.code = (n == null ? void 0 : n.code) || this.details.code || r.UNKNOWN;
  }
};
x.prototype.name = "AppError";
let A = x;
const K = class K extends A {
};
K.prototype.name = "FatalError";
let N = K;
const B = class B extends A {
};
B.prototype.name = "ResetAuthError";
let T = B;
const j = class j extends A {
};
j.prototype.name = "RetryableError";
let b = j;
const q = class q extends b {
};
q.prototype.name = "PushNotificationsDisabledError";
let X = q;
const z = class z extends b {
};
z.prototype.name = "NotEnrolledError";
let k = z;
const Q = class Q extends N {
};
Q.prototype.name = "NetworkError";
let G = Q;
const J = class J extends T {
};
J.prototype.name = "Timeout";
let V = J;
const Z = class Z extends N {
};
Z.prototype.name = "SystemError";
let M = Z;
const _e = (e) => new M({
  code: r.UNKNOWN,
  message: d.SYSTEM_ERROR,
  type: be.SYSTEM,
  ...typeof e == "object" ? e : {}
}), bn = (e, a) => {
  if (console.error("In mapErrorCode", e, a), a === v.IMPR_ID)
    return new T(e);
  switch (!0) {
    case e.code === r.PUSH_NOTIFICATION_NOT_ALLOWED:
      return new X(e);
    case e.code === r.AUTHENTICATOR_NOT_ENROLLED:
      return new k(e);
    case e.code === r.NETWORK_ERROR:
      return new G(e);
    case e.code === r.PUSH_REJECTED:
    case e.code === r.SESSION_EXPIRED:
    case e.code === r.ACCOUNT_DISABLED:
    case e.code === r.ACCOUNT_LOCKED:
    case e.code === r.CREDENTIAL_EXPIRED:
    case e.code === r.PERMISSION_DENIED:
      return new T(e);
    case e.code === r.USER_NOT_FOUND:
    case e.code === r.FACTORS_INSUFFICIENT:
    case e.code === r.AMBIGUOUS_USERNAME:
    case e.code === r.INVALID_CREDENTIALS:
    case e.code === r.INVALID_TOKEN:
    case e.code === r.NO_FACE_DETECTED:
    case e.code === r.LOW_QUALITY:
    case e.code === r.FACE_LIMIT:
    case e.code === r.DUPLICATE:
    case e.code === r.LIVENESS_FAILED:
    case e.code === r.REALNESS_FAILED:
      return new b(e);
    case e.code === r.TERIMINATE_TIMEOUT:
    case e.code === r.TERMINATE_CANCEL:
      return new V({ code: e.code });
    case e.code === r.FAILED_PRECONDITION:
    case e.code === r.INTERNAL:
    case e.code === r.INVALID_TENANT_ID:
    case e.code === r.NOT_FOUND:
    case (e.code === r.SESSION_NOT_FOUND && a === v.FACE_ID):
    case (e.code === r.BAD_REQUEST && a === v.FACE_ID):
    case (e.code === r.ARG_VALIDATION_FAILED && a === v.FACE_ID):
    case e.code === r.ERR_BAD_REQUEST:
    case e.code === r.ERR_NETWORK:
      return new N(e);
    case e.code === r.IMPLEMENTATION_DEFECT:
      return new M({
        code: r.IMPLEMENTATION_DEFECT,
        message: "Wrong session was used for authentication or enrolling"
      });
    case e.message === d.NOT_ENROLLED_CARD:
      return new k(e);
    case e.message === d.CREDENTIAL_EXPIRED:
    case e.message === d.SESSION_EXPIRED:
    case e.message === d.SESSION_ERROR:
    case e.message === d.PUSH_NOTIFICATION_EXPIRED:
    case e.message === d.ACCOUNT_DISABLED:
    case e.message === d.INSUFFICIENT_FACTOR_OPTIONS:
      return new T(e);
    case e.message === d.UXID_MULTIPLEUSERS:
    case e.message === d.NETWORK_ERROR:
    case e.message === d.INCORRECT_PASSWORD:
    case e.message === d.INCORRECT_USER_ID:
    case e.message === d.INCORRECT_USER_NAME:
    case e.message === d.UXID_AUTH_BADTOKENPASSCODE:
    case e.message === d.MISSING_QUERY_PARAMS:
      return new b(e);
    case e.message === d.SYSTEM_ERROR:
    case e.message === d.FATAL_ERROR:
    case e.message === d.INCORRECT_TENANT_ID:
      return new N(e);
    default:
      return _e(e);
  }
}, _n = (e) => ({
  event: e instanceof A ? Y.ERROR : Y.INTERNAL_ERROR,
  data: e instanceof A ? e : _e(e)
}), Va = [
  r.NO_FACE_DETECTED,
  r.FACE_LIMIT,
  r.DUPLICATE,
  r.LOW_QUALITY
], On = (e, a) => {
  const n = !e || le.includes(e);
  switch (ue("handleApiErrors", { status: e, OFFLINE_STATUS_CODES: le, err: a, isNetworkError: n }), !0) {
    case n:
      return new G({
        ...a || {},
        code: r.NETWORK_ERROR,
        message: d.NETWORK_ERROR
      });
    case (e >= Ya || (a == null ? void 0 : a.message) === d.NO_HEALTHY_UPSTREAM):
      return a != null && a.code && Va.includes(a.code) ? void 0 : new N({ code: r.SYSTEM_ERROR, ...a });
    default:
      return;
  }
};
export {
  A,
  mn as B,
  un as C,
  cn as D,
  d as E,
  N as F,
  dn as G,
  An as H,
  Rn as I,
  hn as J,
  on as K,
  ya as L,
  tn as M,
  k as N,
  X as P,
  wa as Q,
  T as R,
  M as S,
  V as T,
  rn as U,
  gn as W,
  D as a,
  b,
  G as c,
  r as d,
  _e as e,
  Tn as f,
  Y as g,
  On as h,
  nn as i,
  Ve as j,
  pn as k,
  In as l,
  bn as m,
  _n as n,
  u as o,
  Ha as p,
  ln as q,
  En as r,
  W as s,
  Sn as t,
  Wa as u,
  Ua as v,
  sn as w,
  Pn as x,
  Nn as y,
  fn as z
};
//# sourceMappingURL=index-B_Mi3W2t.js.map
